import BgImage from '../../../../assets/why_trrip_bg_1769531997717.png';
import { liveTrackingStats } from '../../../../data/landingPage/landingPageData';
import LiveTrackingStatCard from './sections/LiveTrackingStatCard';

const LiveTrackingSection = () => {
  const stats = liveTrackingStats;

  return (
    <section className="py-24 px-4 md:px-8 lg:px-12 relative overflow-hidden bg-gradient-to-br from-[#056766] via-[#067978] to-[#0d9488]">
      {/* Global Network Map Background */}
      <div className="absolute inset-0 z-0">
        <img
          src={BgImage}
          alt="Global Network"
          className="w-full h-full object-cover opacity-10 mix-blend-overlay"
        />
      </div>

      <div className="relative z-10 max-w-7xl 2xl:max-w-[1600px] mx-auto w-full space-y-10 sm:space-y-16">
        <div className="text-center px-4">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-white tracking-tight">
            Your travellers are already exploring
          </h2>
        </div>

        {/* 5 Cards Row */}
        <div className="flex flex-wrap justify-center gap-3 sm:gap-4 md:gap-6">
          {stats.map((stat, idx) => (
            <LiveTrackingStatCard key={idx} stat={stat} idx={idx} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default LiveTrackingSection;
